<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- Header -->
    <div class="flx-modal__header w-f3">
        <div class="with-desc">
            <h2 *ngIf="data.mode == 'create'">{{translate?.general.buttons.configure.singular}} {{translate?.general.buttons.new.singular}} {{translate?.inspection.label.singular}}</h2>
            <h2 *ngIf="data.mode == 'edit'">{{translate?.general.buttons.edit.singular}} {{translate?.inspection.label.singular}}</h2>
        </div>

        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="onCancelClick()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <!-- Body -->
    <div class="flx-modal__body skim gap-3">
        <form [formGroup]="inspectionTypesForm">

            <!-- Inspection Name -->
            <div class="status-field">
                <label class="field-label mandatory">{{translate?.inspection.label.singular}} {{translate?.inspection.fields.name.singular}}</label>
                <div class="field-row field-row--auto">
                    <input type="text" formControlName="name" [placeholder]="'e.g., Monthly Boiler Check'" 
                        pInputText [ngClass]="{
                            'invalid-input':
                                inspectionTypesForm.get('name')?.invalid &&
                                (inspectionTypesForm.get('name')?.dirty || inspectionTypesForm.get('name')?.touched)
                        }">
                </div>
                <div class="p-error text-10" *ngIf="(inspectionTypesForm.controls['name'].touched || inspectionTypesForm.controls['name'].dirty) && inspectionTypesForm.controls['name'].invalid">
                    <div *ngIf="inspectionTypesForm.controls['name'].errors?.required">{{translate?.general.validationFE.requiredField}}</div>
                    <div *ngIf="inspectionTypesForm.controls['name'].errors?.pattern">Only letters and numbers are allowed</div>
                    <div *ngIf="inspectionTypesForm.controls['name'].errors?.maxlength">Maximum length of 255 characters exceeded</div>

                </div>
            </div>

            <!-- Linked Checklist -->
            <div class="status-field">
                <label class="field-label mandatory">{{translate?.inspection.fields.linked.singular}} Checklist</label>
                <div class="field-row field-row--auto">
                    <p-dropdown [placeholder]="translate?.general.buttons.select2.singular + ' ' + translate?.inspection.fields.linked.singular + ' Checklist'" formControlName="checklist" 
                        [options]="linkedChecklist" optionLabel="name" 
                        optionValue="id"></p-dropdown>
                </div>
                <div class="p-error text-10" *ngIf="(inspectionTypesForm.controls['checklist'].touched || inspectionTypesForm.controls['checklist'].dirty) && inspectionTypesForm.controls['checklist'].invalid">
                    <span *ngIf="inspectionTypesForm.controls['checklist'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>

            <!-- Frequency -->
            <div class="status-field">
                <label class="field-label mandatory">{{translate?.inspection.fields.frequency.singular}}</label>
                <div class="field-row field-row--auto">
                    <p-dropdown [options]="frequencyList" optionLabel="fName" 
                        optionValue="fVal" formControlName="frequency" 
                        [placeholder]="translate?.general.buttons.select2.singular + ' ' + translate?.general.messages.aLower + ' ' + (translate?.inspection.fields.frequency.singular | lowercase) + ' ' + translate?.general.messages.forLower + ' ' + translate?.general.messages.thisLower + ' ' + (translate?.inspection.label.singular | lowercase)">
                    </p-dropdown>
                </div>
                <div class="p-error text-10" *ngIf="(inspectionTypesForm.controls['frequency'].touched || inspectionTypesForm.controls['frequency'].dirty) && inspectionTypesForm.controls['frequency'].invalid">
                    <span *ngIf="inspectionTypesForm.controls['frequency'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>

            <!-- Start Date -->
            <div class="status-field">
                <label class="field-label mandatory">{{translate?.maintenance.fields.startDate.singular}}</label>
                <div class="field-row field-row--auto">
                        <p-calendar [minDate]="minDate" [defaultDate]="defaultDate" name="startDate" [showIcon]="true"
                            selectionMode="single" formControlName="startDate" styleClass="cal-btn"
                            dateFormat="dd/mm/yy" yearRange="2000:2030" type="text" placeholder="dd/mm/yy"
                        [yearNavigator]="true" appendTo="body"></p-calendar>
                </div>
                <div class="p-error text-10"
                    *ngIf="(inspectionTypesForm.controls['startDate'].touched || inspectionTypesForm.controls['startDate'].dirty) && inspectionTypesForm.controls['startDate'].invalid">
                    <span *ngIf="inspectionTypesForm.controls['startDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>

            <!-- Due Date Derivation -->
            <div class="status-field">
                <div class="flex-align-baseline gap-2">
                    <label class="field-label mandatory">Due Date Derivation</label>
                    <span><i class="pi pi-info-circle" pTooltip="Option for when the next inspection should be generated"></i></span>
                </div>
                <div class="field-row field-row--auto">
                    <p-dropdown formControlName="dueDateDerivation" [options]="dueDateOptions" 
                        optionLabel="name" optionValue="value" [placeholder]="'Select a due date derivation'">
                    </p-dropdown>
                </div>
                <div class="p-error text-10" *ngIf="(inspectionTypesForm.controls['dueDateDerivation'].touched || inspectionTypesForm.controls['dueDateDerivation'].dirty) && inspectionTypesForm.controls['dueDateDerivation'].invalid">
                    <span *ngIf="inspectionTypesForm.controls['dueDateDerivation'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>

        </form>
    </div>

    <!-- Footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="onCancelClick()">
            {{ translate?.general.buttons.cancel.singular }}
        </button>
        <p-button styleClass="h-32" type="button" (onClick)="onInspectionAdd()" [disabled]="inspectionTypesForm.invalid" [label]="translate?.general.buttons.save.singular"></p-button>
    </div>
</div>